import { InertiaApp } from "@inertiajs/inertia-react";
import React from "react";
import { render } from "react-dom";
import _JSXStyle from "styled-jsx/style";

const app = document.getElementById("app");

if (typeof global !== "undefined") {
    Object.assign(global, { _JSXStyle });
}

render(
    <InertiaApp
        initialPage={JSON.parse(app.dataset.page)}
        resolveComponent={(name) => require(`./pages/${name}`).default}
    />,
    app,
);
